import { createAction, props } from '@ngrx/store';
export const setReportName = createAction('[Custom PDF Report Builder] Set Report Name', props());
